var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading_solutions)?[(_vm.is_resolve)?_c('resolve-dash'):_vm._e(),(_vm.is_corona)?_c('combat-dash'):_vm._e(),(_vm.is_pallet)?_c('pallet-dash'):_vm._e(),(_vm.is_compliance)?_c('router-view'):_vm._e()]:_vm._e(),(_vm.loading_solutions)?[_c('card-loading-transparent',{attrs:{"light":""}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }